import {
  FETCH_PACKAGE_EVIDENCES_REQUEST,
  FETCH_PACKAGE_EVIDENCES_SUCCESS,
  FETCH_PACKAGE_EVIDENCES_FAILURE,
} from "./types";

import { fetchPackageEvidencesByPackageId } from "../../services/packageEvidenceService";


export const fetchPackageEvidencesRequest = () => ({
  type: FETCH_PACKAGE_EVIDENCES_REQUEST,
});

export const fetchPackageEvidencesSuccess = (data) => ({
  type: FETCH_PACKAGE_EVIDENCES_SUCCESS,
  payload: data, 
});

export const fetchPackageEvidencesFailure = (error) => ({
  type: FETCH_PACKAGE_EVIDENCES_FAILURE,
  payload: error,
});


export const fetchPackageEvidencesAction =
  (packageId) =>
  async (dispatch) => {
    dispatch(fetchPackageEvidencesRequest());

    try {
      const response = await fetchPackageEvidencesByPackageId(packageId);

      if (response?.error) {
        dispatch(fetchPackageEvidencesFailure(response.error));
        return { success: false, error: response.error };
      }

      dispatch(fetchPackageEvidencesSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      const msg = error.message || "Failed to fetch package evidences";
      dispatch(fetchPackageEvidencesFailure(msg));
      return { success: false, error: msg };
    }
  };
